export default __webpack_public_path__ + "static/media/12-sleeping-face_1f634.875d5dde.png";